import type { GriffelStyle } from '@fluentui/react-components';

/**
 * Style snippet that reveals the nested {@link OperationInfoButton} and
 * {@link OperationFavoriteButton} icons on `:hover` / `:focus-within`.
 * Spread into a `makeStyles` entry on the parent row that contains them.
 *
 * The class names are literal strings (kept in sync with
 * `OPERATION_INFO_REVEAL_CLASS` / `OPERATION_FAVORITE_REVEAL_CLASS`) so
 * Griffel can statically extract them and parent selectors don't depend
 * on import order.
 */
export const operationRowRevealStyle: GriffelStyle = {
  ':hover .otto-op-info': { opacity: 1 },
  ':focus-within .otto-op-info': { opacity: 1 },
  ':hover .otto-op-favorite': { opacity: 1 },
  ':focus-within .otto-op-favorite': { opacity: 1 },
};
